import { Action } from "../shared/Action";
import { LocationInfo } from "../shared/models/Location";

type ChangeMapLocations = Action<"MAP/LOCATIONS/CHANGE", Array<LocationInfo>>;

export function changeMapLocations(
  locations: Array<LocationInfo>
): ChangeMapLocations {
  return {
    type: "MAP/LOCATIONS/CHANGE",
    value: locations
  };
}

type ChangeQuery = Action<"MAP/QUERY/CHANGE", string>;

export function changeQuery(query: string): ChangeQuery {
  return {
    type: "MAP/QUERY/CHANGE",
    value: query
  };
}

type ChangeRocFilter = Action<"MAP/FILTER/CHANGE", boolean>;

export function changeRocFilter(value: boolean): ChangeRocFilter {
  return {
    type: "MAP/FILTER/CHANGE",
    value
  };
}

type RefreshMap = Action<"MAP/REFRESH", null>;

export function refreshMap(): RefreshMap {
  return {
    type: "MAP/REFRESH",
    value: null
  };
}

type SelectLocation = Action<"MAP/LOCATION/SELECT", LocationInfo | null>;

export function selectLocation(location: LocationInfo | null): SelectLocation {
  return {
    type: "MAP/LOCATION/SELECT",
    value: location
  };
}

type UpdateMap = Action<"MAP/CHANGE", google.maps.Map | null>;

export function updateMap(map: google.maps.Map | null): UpdateMap {
  return {
    type: "MAP/CHANGE",
    value: map
  };
}

export type MapActions =
  | ChangeMapLocations
  | ChangeQuery
  | ChangeRocFilter
  | RefreshMap
  | SelectLocation
  | UpdateMap;
